import axios from "axios";
import Cookies from "js-cookie";

const REACT_APP_API_URL = process.env.REACT_APP_NODE_ENV === "PRD" ?  process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_NODE_ENV === "STG" ? process.env.REACT_APP_API_URL_STAGING : process.env.REACT_APP_API_URL_LOCAL;

const token = Cookies.get("hippocratic_portal_token");

// const _getHeaders = () => {
//   return { Authorization: `Bearer ${token}` };
// };

const get = (endpoint, id) => {
  if (id) return axios.get(REACT_APP_API_URL + endpoint + "/" + id);
  return axios.get(REACT_APP_API_URL + endpoint);
};

const post = (endpoint, data) => {
  return axios.post(REACT_APP_API_URL + endpoint, { ...data, token: token });
};

const postWithheader = (endpoint, data) => {
  return axios.post(
    REACT_APP_API_URL + endpoint,
    { ...data, token: token },
    {
      headers: { "x-api-key": process.env.REACT_APP_API_KEY },
    }
  );
};

class WebApiClient {
  me(id) {
    return post("/api/BackEnd/GetUserInfo", {
      contactid: id,
    });
  }

  Login(Username, Password) {
    return post("/api/BackEnd/ValidateLoginCreds", {
      username: Username,
      password: Password,
    });
  }

  ValidateRegister(source, username, password, contactId, code) {
    return post("/api/BackEnd/ValidateRegister", {
      source: source,
      username: username,
      password: password,
      contactId: contactId,
      code: code,
    });
  }
  InvitationCode(invitationCode) {
    return post("/api/BackEnd/ValidateInvitationCode", {
      invitationCode: invitationCode,
    });
  }
  ValidateOtp(code) {
    return post("/api/BackEnd/ValidateOTP", {
      code: code,
    });
  }
  getUserInfo(contactid) {
    return post("/api/BackEnd/GetUserInfo", {
      contactid: contactid,
    });
  }
  getTrainingProgram(type) {
    return post("/api/BackEnd/GetTrainingPrograms", {
      type: type,
    });
  }
  getTrainingHospitals(id) {
    return postWithheader("/api/BackEnd/GetTrainingHospitals", {});
  }
  getSpecialties(id) {
    return postWithheader("/api/BackEnd/GetSpecialties", {});
  }
  getActiveWMAccountsUOM(contactid) {
    return post("/api/BackEnd/GetActiveWMAccountsUOM", {
      contactid: contactid,
    });
  }
  getAllInforcePolicies(contactid) {
    return post("/api/BackEnd/GetAllInforcePolicies", {
      contactid: contactid,
    });
  }
  getMembers(contactid) {
    return post("/api/BackEnd/GetHouseholdMembers", {
      contactid: contactid,
    });
  }
  updateRecord(props) {
    return post("/api/BackEnd/UpdateRecord", props);
  }
  UpdateLead(props) {
    return postWithheader("/api/BackEnd/UpdateLead", props);
  }
  getLeadInfo(id) {
    return postWithheader("/api/BackEnd/RetrieveLeadInfo", { id: id });
  }
  getNonTrainingProgram() {
    return post("/api/BackEnd/GetNonTrainingPrograms");
  }
  createRecord(props) {
    return post("/api/BackEnd/CreateContact", props);
  }
  getFolders(props) {
    return post("/api/BackEnd/RetrieveFolderContents", props);
  }
  uploadFile(props) {
    return post("/api/BackEnd/UploadFile", props);
  }
  createFolder(props) {
    return post("/api/BackEnd/CreateFolder", props);
  }
  changePassword(props) {
    return post("/api/BackEnd/ResetPassword", props);
  }

  getOTPExpiry() {
    return post("/api/BackEnd/GetOTPExpiry", {});
  }

  sendOTP() {
    return post("/api/BackEnd/SendOTP", {});
  }

  validateOtpOld(otp, username) {
    return post("/api/BackEnd/ValidateOTPOldContacts", {
      oldUsername: username,
      code: otp,
    });
  }

  validateOTPCurrent(otp) {
    return post("/api/BackEnd/ValidateOTPCurrent", {
      code: otp,
    });
  }

  ValidateMigration(username) {
    return post("/api/BackEnd/ValidateMigration", { username: username });
  }

  ValidateUsername(username) {
    return post("/api/BackEnd/ValidateUsername", { username: username });
  }

  ForgetPassword(props) {
    return post("/api/BackEnd/ForgotPassword", props);
  }
}

export default WebApiClient;
